/* jt-tp-mini-carousel */
(function () {
  function initMiniCarousel(root) {
    if (!root || root.getAttribute('data-jt-tp-init') === '1') return;
    var track = root.querySelector('.tp-mini-carousel__track');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.tp-mini-carousel__slide'));
    var prevBtn = root.querySelector('.tp-mini-carousel__arrow--prev');
    var nextBtn = root.querySelector('.tp-mini-carousel__arrow--next');
    var dotsWrap = root.querySelector('.tp-mini-carousel__dots');
    if (!track || !slides.length) return;
    root.setAttribute('data-jt-tp-init', '1');

    var index = parseInt(root.getAttribute('data-jt-tp-idx') || '0', 10) || 0;

    if (dotsWrap && !dotsWrap.children.length) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'tp-mini-carousel__dot';
        dot.setAttribute('aria-label', 'Review ' + (i + 1));
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(i);
        });
        dotsWrap.appendChild(dot);
      });
    }

    function update() {
      var viewport = root.querySelector('.tp-mini-carousel__viewport') || root;
      var slideW = slides[0].getBoundingClientRect().width || viewport.clientWidth;
      track.style.transform = 'translateX(-' + (index * slideW) + 'px)';
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.querySelectorAll('.tp-mini-carousel__dot'), function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      if (prevBtn) prevBtn.classList.toggle('is-disabled', index <= 0);
      if (nextBtn) nextBtn.classList.toggle('is-disabled', index >= slides.length - 1);
      root.setAttribute('data-jt-tp-idx', String(index));
    }

    function goTo(i) {
      index = Math.max(0, Math.min(slides.length - 1, i));
      update();
    }

    root.__jtTpGoTo = goTo;
    root.__jtTpUpdate = update;

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index - 1);
      }, true);
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(index + 1);
      }, true);
    }

    update();
    window.addEventListener('resize', function () { update(); });
  }

  function boot() {
    document.querySelectorAll('.tp-mini-carousel').forEach(initMiniCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  [300, 1000, 3000, 8000, 15000].forEach(function (ms) { setTimeout(boot, ms); });
  document.addEventListener('shopify:section:load', boot);
})();
